<template lang="html">
<d-container fluid>
  <!-- Small Stats Blocks -->
  <d-row>
    <d-col lg v-for="(stats, idx) in smallStats" :key="idx" class="mb-4">
      <small-stats :id="`small-stats-${idx}`" variation="1" :chart-data="stats.datasets" :label="stats.label" :value="stats.value" :percentage="stats.percentage" :increase="stats.increase" :decrease="stats.decrease" />
    </d-col>
  </d-row>

  <d-row v-if="hasAccessTickets">
    <!-- Ticket -->
    <d-col lg="12" md="6" sm="12" class="mb-4">
      <d-card class="card-small">

        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <h6 class="m-0">Lista dos Chamados</h6>
          <div class="block-handle"></div>
        </d-card-header>

        <d-card-body>
          <ticket-table :tickets="tickets.list" />
        </d-card-body>
      </d-card>
    </d-col>
  </d-row>
</d-container>
</template>

<script>
import { mapActions } from 'vuex';
import SmallStats from '_common/components/dashboard/SmallStats.vue';
import DashboardService from '_services/rest/modules/dashboard';
import TicketTable from '_modules/ticket/components/TicketListTable.vue';

export default {
  name: 'dashboard-staff',
  components: {
    SmallStats,
    TicketTable,
  },
  computed: {
    tickets() {
      const { ticketList } = this.$store.state.ticket;
      if (ticketList && ticketList.list.length) {
        return ticketList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    hasAccessTickets() {
      const { modules } = this.$store.state.user;
      return modules.includes('tickets');
    },
  },
  data() {
    return {
      smallStats: null,
      pagination: {
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  methods: {
    ...mapActions([
      'getTicketList',
    ]),
    getList() {
      this.getTicketList(this.pagination);
    },
    getQuotationsStats() {
      DashboardService.getStatsDashboard()
        .then(response => {
          this.smallStats = response;
        });
    },
  },
  mounted() {
    if (this.hasAccessTickets) this.getList();
    this.getQuotationsStats();
  },
};
</script>
